/**
 * Browser entry: attach handlers used by inline onclick attributes in mindlift-funnel.html.
 */
import {
  next,
  goBack,
  pick,
  pickScale,
  pickG,
  checkName,
  landPick,
  landContinue,
  openFullPlanFromAnalysis
} from './funnel-flow.js';

Object.assign(window, {
  next,
  goBack,
  pick,
  pickScale,
  pickG,
  checkName,
  landPick,
  landContinue,
  openFullPlanFromAnalysis
});

